export interface PreviewPalette {
  accent?: string;
  neutralSecondary?: string;
  themePrimary?: string;
}

export interface PreviewStyleOptions {
  iconFontFamily?: string;
  palette?: PreviewPalette;
}

export const getExtensionPreviewStyles = () => ({
  '& .bing-desktop-img': {
    border: '0.5px solid #ddd',
    width: '548px',
    height: '242px',
    padding: '10px',
    '& .text-container': {
      height: '110px',
      '& .ad-logo': {
        position: 'absolute',
        color: '#999',
        fontWeight: 'bold',
        backgroundColor: '#fff',
        lineHeight: '0.05em',
        fontSize: '7px',
        border: '0.5px solid #ddd',
        borderRadius: '4px',
        padding: '4px 1px 0px 1px',
        '& p': {
          margin: '0 0 5px !important',
        },
      },
      '& .long-headline': {
        fontSize: '20px',
        fontWeight: 'bold',
        width: '548px',
        position: 'relative',
        overflow: 'hidden',
        color: '#003DC1',
        lineHeight: '25px',
      },
      '& .final-url': {
        width: '548px',
        position: 'relative',
        overflow: 'hidden',
        color: '#0b6a0b',
        fontSize: '12px',
      },
      '& .description': {
        margin: '2px 0px 7px 0px',
        color: '#333',
        fontSize: '12px',
      },
    },
    '& .image-combo-contanier': {
      float: 'left',
      marginRight: '5px',
      height: '135px',
      borderRadius: '6px',
      border: '0.5px solid #ddd',
      width: '130px',
      overflow: 'hidden',
      '& .image-container': {
        overflow: 'hidden',
      },
      '& .text-container': {
        height: '45px',
        padding: '2px',
        '& .extension-headline': {
          fontSize: '13px',
          lineHeight: '15px',
          height: '32px',
          color: '#003DC1',
          fontWeight: 'normal',
        },
      },
    },
  },
  '& .mobile-multi-img': {
    borderRadius: '6px',
    border: '0.5px solid #ddd',
    '& .ad-logo': {
      position: 'absolute',
      color: '#fff',
      backgroundColor: '#666',
      top: '10px',
      left: '5px',
      lineHeight: '0.1em',
      border: '1px solid #ddd',
      borderRadius: '6px',
      padding: '5px 1px 2px 1px',
      '& p': {
        margin: '0 0 5px !important',
      },
    },
    '& .text-container': {
      height: '118px',
      padding: '10px',
      width: '400px',
      '& .long-headline': {
        fontWeight: '400',
        fontSize: '18px',
        width: '100%',
        height: '24px',
        color: '#003DC1',
      },
      '& .final-url': {
        width: '100%',
        height: '20px',
        position: 'relative',
        overflow: 'hidden',
        color: '#0b6a0b',
        borderBottom: '1px solid #ddd',
        paddingBottom: '6px',
        marginBottom: '6px',
        fontWeight: '400',
        fontSize: '14px',
      },
      '& .description': {
        height: '40px',
        margin: '2px 0px 7px 0px',
        color: '#333',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '20px',
      },
    },
  },
  '& .bing-single-image': {
    border: '0.5px solid #ddd',
    width: '608px',
    height: '110px',
    padding: '3px',
    '& .image-container': {
      float: 'right',
      transform: 'translate(20px,20px)',
      width: '100px',
      height: '75px',
      margin: '8px',
    },
    '& .text-container': {
      margin: '4px 8px 0px 8px',
      '& .long-headline': {
        fontWeight: '400',
        fontSize: '20px',
        lineHeight: '24px',
        height: '28px',
        overflow: 'hidden',
      },
      '& .final-url': {
        overflow: 'hidden',
        color: '#0b6a0b',
        fontSize: '14px',
        height: '20px',
      },
      '& .description': {
        color: '#333',
        fontSize: '13px',
      },
    },
  },
});

export const multiImageInnerCarouselStyles = (palette: PreviewPalette, iconFontFamily: string) => ({
  '& .mobile-multi-img .image-combo-contanier': {
    '& .carousel-inner': {
      paddingBottom: 0,
    },
  },

  '& .ad-preview-title': {
    fontSize: 18,
    fontWeight: 'normal',
    lineHeight: '24px',
    margin: '20px 24px 16px 24px',
  },

  '& .carousel-inner': {
    paddingBottom: 64,
    '& > .item.active': {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },

  '& ol.carousel-indicators': {
    position: 'absolute',
    bottom: 0,
    left: 0,
    margin: '20px 24px',
    width: 'auto',

    '& li': {
      background: 'rgba(255, 255, 255, 0.8)',
      border: '1px solid #605E5C',
      borderRadius: 10,
      margin: '0 10px 0 0',
      height: 10,
      width: 10,
    },

    '& li.active': {
      background: palette.themePrimary,
      border: `1px solid ${palette.themePrimary}`,
      '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
        border: '5px solid ButtonText',
      },
    },
  },

  '& .carousel-controls': {
    display: 'none',
  },

  '& .carousel-control': {
    color: palette.themePrimary,
    position: 'absolute',
    left: 'auto',
    top: 'auto',
    right: 0,
    bottom: 0,
    height: 32,
    width: 16,
    paddingRight: 4,
    margin: '20px 24px',
    textShadow: 'none',
    background: 'rgba(255, 255, 255, 0.6)',

    '&.left': {
      marginRight: 76,
    },

    '& .glyphicon-chevron-left, & .glyphicon-chevron-right': {
      fontFamily: iconFontFamily,
      position: 'relative',
      top: 'auto',
      right: 'auto',
      bottom: 'auto',
      left: 'auto',
      margin: 0,
      fontSize: 16,
      lineHeight: 1,
      verticalAlign: 0,
    },
  },
});
